import { render, staticRenderFns } from "./IosAddToHomeDialog.vue?vue&type=template&id=5c7ab4ba&scoped=true&"
import script from "./IosAddToHomeDialog.vue?vue&type=script&lang=js&"
export * from "./IosAddToHomeDialog.vue?vue&type=script&lang=js&"
import style0 from "./IosAddToHomeDialog.vue?vue&type=style&index=0&id=5c7ab4ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7ab4ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDialog,VIcon})
